import {$qsAll} from '../../../../@shared/ts/dom';
import {type LoadingMode, type ModalPage} from '../../models/IEnvironment';
import {DefaultCart} from '../../reducers/cartReducer';
import {Environment} from '../../reducers/environmentReducer';
import {PaymentConfiguration} from '../../reducers/paymentConfigurationReducer';
import {store} from '../../store';
import {formatCurrencyString} from '../../util/currency';
import {getLocaleText} from '../../util/translation';

export function setupAuthnetButton() {
	store.subscribe(() => {
		renderAuthnetButtonDisplay(
			PaymentConfiguration.selectedGateway(),
			Environment.modalUI.page(),
			Environment.modalUI.loadingMode(),
		);

		renderAuthnetButtonLoading(
			Environment.modalUI.loadingMode(),
		);
	});
}

/**
 * Renders the Authorize.net button display state.
 */

function renderAuthnetButtonDisplay(gatewayId: string, page: ModalPage, loadingMode: LoadingMode) {
	// Show/hide Authnet button container
	if (gatewayId.startsWith('peachpay_authnet_') && page === 'payment') {
		$qsAll('.authnet-btn-container', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.authnet-btn-container', $element => {
			$element.classList.add('hide');
		});
	}

	// Hide/Show button
	if (loadingMode === 'loading') {
		$qsAll('.authnet-btn', $element => {
			$element.classList.add('hide');
		});
	} else {
		$qsAll('.authnet-btn', $element => {
			$element.classList.remove('hide');
		});
	}
}

function renderAuthnetButtonLoading(mode: LoadingMode) {
	// Show/hide the external spinner
	if (mode === 'loading') {
		$qsAll('.authnet-spinner-container', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.authnet-spinner-container', $element => {
			$element.classList.add('hide');
		});
	}

	// Show/hide the internal spinner
	if (mode === 'processing') {
		$qsAll('.authnet-btn-spinner', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.authnet-btn-spinner', $element => {
			$element.classList.add('hide');
		});
	}

	// Show/hide processing message
	if (mode === 'processing') {
		$qsAll('.authnet-btn > .button-text', $element => {
			$element.innerHTML = getLocaleText('Processing');
		});
	} else {
		$qsAll('.authnet-btn > .button-text', $element => {
			$element.innerHTML = `${getLocaleText('Pay')} ${formatCurrencyString(DefaultCart.total())}`;
		});
	}

	// Enable/disable the authnet button
	if (mode === 'finished') {
		$qsAll<HTMLInputElement>('.authnet-btn', $element => {
			$element.disabled = false;
		});
	} else {
		$qsAll<HTMLInputElement>('.authnet-btn', $element => {
			$element.disabled = true;
		});
	}
}
